import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "address-header" }
const _hoisted_3 = ["onMouseenter"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "no-data"
}
const _hoisted_7 = {
  key: 2,
  class: "no-data"
}

import AccordionCardInfoDisplay from '@/components/features/info-display/AccordionCardInfoDisplay.vue'
import TableMini from '@/design-system/molecules/TableMini.vue'
import TooltipStandard from '@/design-system/atoms/TooltipStandard.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { computed, ref } from 'vue'
import { Apartment, CoreEntityDto } from '@/interfaces/core.interface'
import { useI18n } from 'vue-i18n'
import { useSelectionStore } from '@/pinia/selection'
import { storeToRefs } from 'pinia'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoDisplayApartmentsCard',
  props: {
    showForEntityTypes: {},
    currentEntity: {},
    title: {},
    isLoading: { type: Boolean },
    expanded: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const selectionStore = useSelectionStore()
const { t } = useI18n()
const isExpanded = ref(props.expanded)
const hoveredItem = ref(null)
const hoveredTitle = ref('')
const showTooltip = ref(false)
const trackedMouseEvent = ref({ x: 0, y: 0 })
const lastMousePosition = ref([0, 0])
const headers = computed(() => {
  return {
    heading1: t('general__data__apartment-number'),
    heading2: t('general__data__area-boa-short'),
    heading3: t('general__data__rooms')
  }
})
const currentEntity = computed(() => props.currentEntity)
const { clickedEntityType } = storeToRefs(selectionStore)

// methods
function getContentData(apartments: Apartment[]) {
  return apartments.map((apartment) => {
    return {
      value1: apartment.apartmentNumber ? apartment.apartmentNumber.toString() : '-',
      value2: apartment.livingSurface ? apartment.livingSurface.toString() : '-',
      value3: apartment.numberOfRooms ? apartment.numberOfRooms.toString() : '-'
    }
  })
}
function handleClick() {
  isExpanded.value = !isExpanded.value
}
function handleHover(item) {
  hoveredItem.value = item
}
function trackPointer(event, title) {
  hoveredTitle.value = title
  const rect = event.currentTarget.getBoundingClientRect()
  if (event) {
    if (
      lastMousePosition.value[0] === event.clientX &&
      lastMousePosition.value[1] === event.clientY
    )
      return
    lastMousePosition.value = [event.clientX, event.clientY]
    trackedMouseEvent.value = {
      x: rect.left + rect.width / 2,
      y: rect.bottom + rect.height / 2
    }
    const targetEl = event.target
    if (targetEl.firstElementChild) {
      showTooltip.value =
        targetEl.firstElementChild.clientWidth < targetEl.firstElementChild.scrollWidth
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_ctx.showForEntityTypes.includes(_unref(clickedEntityType)) && currentEntity.value)
    ? (_openBlock(), _createBlock(AccordionCardInfoDisplay, {
        key: 0,
        heading: _ctx.title,
        isExpanded: isExpanded.value,
        contentHeight: !_ctx.isLoading ? '240px' : undefined,
        onOnClicked: handleClick
      }, {
        content: _withCtx(() => [
          (!_ctx.isLoading && currentEntity.value.authorityData?.apartmentsInfo?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentEntity.value.authorityData?.apartmentsInfo, (info, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "accordion"
                  }, [
                    _createElementVNode("p", _hoisted_2, _toDisplayString(info.address), 1),
                    (info.apartments.length)
                      ? (_openBlock(), _createBlock(TableMini, {
                          key: 0,
                          items: getContentData(info.apartments),
                          widthHeading2: "'fit-content'",
                          widthHeading3: "64px",
                          widthValue1: '55%',
                          widthValue2: 'fit-content',
                          widthValue3: '60px',
                          unlimitedLength: true,
                          onOnHovered: handleHover
                        }, {
                          heading1: _withCtx(() => [
                            _createTextVNode(_toDisplayString(headers.value.heading1), 1)
                          ]),
                          heading2: _withCtx(() => [
                            _createTextVNode(_toDisplayString(headers.value.heading2), 1)
                          ]),
                          heading3: _withCtx(() => [
                            _createTextVNode(_toDisplayString(headers.value.heading3), 1)
                          ]),
                          value1: _withCtx(({ item }) => [
                            _createElementVNode("div", {
                              class: "table-cell",
                              onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (showTooltip.value = false)),
                              onMouseenter: (e) => trackPointer(e, item.value1)
                            }, [
                              _createElementVNode("p", null, _toDisplayString(item.value1), 1),
                              _withDirectives(_createVNode(TooltipStandard, {
                                arrowPosition: "top-center",
                                class: "tooltip",
                                pointerEvent: trackedMouseEvent.value,
                                text: hoveredTitle.value
                              }, null, 8, ["pointerEvent", "text"]), [
                                [_vShow, showTooltip.value]
                              ])
                            ], 40, _hoisted_3)
                          ]),
                          value2: _withCtx(({ item }) => [
                            item
                              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.value2), 1))
                              : _createCommentVNode("", true)
                          ]),
                          value3: _withCtx(({ item }) => [
                            item
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.value3), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["items"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : (!_ctx.isLoading && !currentEntity.value.authorityData?.apartmentsInfo?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('general__data__no-data-published')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(PulseLoader, {
                    loading: true,
                    color: "#3F46D6"
                  })
                ]))
        ]),
        _: 1
      }, 8, ["heading", "isExpanded", "contentHeight"]))
    : _createCommentVNode("", true)
}
}

})